import type { UserProfile } from "@shared/types";
import { SetErrorAction, SetLoadingAction, SetProfileAction, SetSavingAction, UserProfileActions, UserProfileState } from "./types";

export const initialState: UserProfileState = {
  profile: undefined,
  isLoading: false,
  isSaving: false,
  error: undefined,
};

export function setProfile(profile: UserProfile | undefined): SetProfileAction {
  return { type: "SET_PROFILE", payload: { profile } };
}

export function setLoading(isLoading: boolean): SetLoadingAction {
  return { type: "SET_LOADING", payload: { isLoading } };
}

export function setSaving(isSaving: boolean): SetSavingAction {
  return { type: "SET_SAVING", payload: { isSaving } };
}

export function setError(error: string | undefined): SetErrorAction {
  return { type: "SET_ERROR", payload: { error } };
}

export function reducer(state: UserProfileState, action: UserProfileActions): UserProfileState {
  switch (action.type) {
    case "SET_PROFILE":
      return { ...state, profile: action.payload.profile };
    case "SET_LOADING":
      return { ...state, isLoading: action.payload.isLoading };
    case "SET_SAVING":
      return { ...state, isSaving: action.payload.isSaving };
    case "SET_ERROR":
      return { ...state, error: action.payload.error };
    default:
      return state;
  }
}
